import React from "react";
import PropTypes from "prop-types";
import { motion, AnimatePresence } from "framer-motion";
import { FaCheckCircle, FaTimesCircle, FaInfoCircle } from "react-icons/fa";
import clsx from "clsx";

const sizeIcon = 24;

const iconMap = {
  success: <FaCheckCircle size={sizeIcon} />,
  error: <FaTimesCircle size={sizeIcon} />,
  info: <FaInfoCircle size={sizeIcon} />,
};

const colorMap = {
  success: {
    solid: "bg-green-500 text-white",
    soft: "bg-green-500/20 text-green-700 backdrop-blur-md",
  },
  error: {
    solid: "bg-red-500 text-white",
    soft: "bg-red-500/20 text-red-700 backdrop-blur-md",
  },
  info: {
    solid: "bg-yellow-500 text-white",
    soft: "bg-yellow-500/20 text-yellow-700 backdrop-blur-md",
  },
};

const Toast = ({
  visible,
  message = "",
  type = "success",
  variant = "solid", // "solid" | "soft"
  className = "",
  children,
}) => {
  const icon = iconMap[type] || iconMap.info;
  const colors = colorMap[type] || colorMap.info;

  const variantClasses = colors[variant] || colors.solid;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, x: -50, scale: 0.95 }}
          animate={{ opacity: 1, x: 0, scale: 1 }}
          exit={{ opacity: 0, x: -50, scale: 0.95 }}
          transition={{ duration: 0.3 }}
          className={clsx(
            "flex items-center gap-3 rounded-md px-6 py-4 shadow-md",
            variantClasses,
            className,
          )}
        >
          {icon}

          {/* prioridad: children > message */}
          <div className="flex-1">{children ? children : message}</div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Toast;

Toast.propTypes = {
  visible: PropTypes.bool.isRequired,
  message: PropTypes.node,
  type: PropTypes.oneOf(["success", "error", "info"]),
  variant: PropTypes.oneOf(["solid", "soft"]),
  className: PropTypes.string,
  children: PropTypes.node,
};
